import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import VaFileUploadList from './VaFileUploadList.vue'

export default withConfigTransport(VaFileUploadList)
